import styled from "styled-components"

const StyledProgram = styled.section`
  padding: 120px 0 170px;
  position: relative;
  z-index: 0;
  .text-label {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .program {
    &__container {
      text-align: center;
    }

    &__header {
      max-width: 568px;
      margin: 0 auto;
      font-size: 48px;
      line-height: 61px;
    }

    &__logo {
      margin: 0 auto 50px;
      max-height: 100px;
    }

    &__subheader {
      font-weight: 600;
      font-size: 24px;
    }

    &__description {
      max-width: 548px;
      margin: 15px auto 0;
    }

    &__circle {
      &-wrapper {
        position: relative;
        overflow: hidden;

        .item {
          transition: all 150ms linear;

          &-enter {
            opacity: 0;

            &-active {
              opacity: 1;
              transition: opacity 300ms linear;
            }
          }

          &-exit {
            opacity: 1;

            &-active {
              opacity: 0;
              transition: opacity 300ms linear;
            }
          }
        }
      }

      &-description {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        max-width: 236px;
        margin: 0 auto;
        z-index: 9;

        p {
          line-height: 1.2;
          margin: 10px 0 0 0;
        }
      }

      &-image {
        max-height: 596px;
        display: flex;
        align-items: center;
        justify-content: center;

        @media (max-width: 768px) {
          width: calc(100% + 60px);
          position: relative;
          left: -30px;
        }

        img {
          height: auto;
          max-width: 100%;
          max-height: 596px;
        }
      }

      &-nav {
        max-width: 636px;
        margin: 0 auto;
        border: 1px solid #000;
        border-radius: 21px;
        padding: 0 0 30px 0;

        button {
          display: inline-flex;
          align-items: center;
          border: 0;
          background: transparent;
          text-transform: uppercase;
          font-weight: 700;
          min-height: 34px;
          border-radius: 24px;
          transition: all 150ms linear;
          margin: 30px 15px 0;
          padding: 0 10px 0 4px;
          color: #000;
          &:before {
            content: "";
            width: 22px;
            height: 22px;
            border: 2px solid #000;
            border-radius: 50%;
            display: inline-flex;
            margin: 0 15px 0 0;
            transition: all 150ms linear;
          }

          &:hover {
            &:before {
              background-color: #00fb6e;
            }
          }

          &.current {
            background-color: #000;
            color: #fff;

            &:before {
              border-color: #00fb6e;
              background-color: #00fb6e;
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 800px) {
    padding: 90px 0;
    .program {
      &__header {
        max-width: 468px;
        font-size: 34px;
        line-height: 43px;
      }
      &__logo {
        margin: 40px 0;
      }
      &__description {
        margin: 30px auto;
      }
      &__circle {
        &-description {
          max-width: 200px;
          p {
            font-size: 14px;
            line-height: 16px;
          }
        }
        &-nav {
          margin-top: 30px;
        }
      }
    }
  }
  @media screen and (max-width: 600px) {
    .program {
      &__circle {
        &-description {
          max-width: 180px;
          p {
            margin-top: 5px;
            font-size: 12px;
            line-height: 14px;
          }
        }
        &-nav {
          padding-bottom: 12px;
          button {
            min-height: 26px;
            margin: 12px 10px 0;
            padding: 0 10px 0 4px;
            font-size: 11px;
            &:before {
              width: 15px;
              height: 15px;
              margin: 0 9px 0 0;
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 500px) {
    .program {
      &__circle {
        &-description {
          max-width: 150px;
          p {
            font-size: 11px;
            line-height: 13px;
          }
        }
      }
    }
  }
`
export default StyledProgram
